'use strict';

function FooterController($scope) {

}

module.exports = {
    FooterController: FooterController
};
